module.exports = __webpack_public_path__ + "img/icon_4_46.f9574a7c.png";